export default __webpack_public_path__ + "static/media/Pin_Job_Engine.da4d1940.svg";